import ApiService from '../service/ApiService';

let moduleApi = {};
let moduleName = "province";

moduleApi.list = async (dataFilter) => {
    let api = {
        module: moduleName,
        type: "list",
        value: dataFilter
    };
    
  const result = await ApiService(api);
  mushroom[moduleName].invalidCache();
  return result;
};

moduleApi.findById = async (id) => {
    let api = {
        module: moduleName,
        type: "findById",
        value: { id: id }
    };
    
  const result = await ApiService(api);
  mushroom[moduleName].invalidCache();
  return result;
};


export default moduleApi;